import { ReactComponent as FlagIcon } from "./svg/ve-flag.svg";
import "../flag-icon.scss";

export const VEFlag = () => {
  return (
    <span className="flag-icon">
      <FlagIcon />
    </span>
  );
};
